import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchCollections(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/collection_vouchers/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchCollection(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/collection_vouchers/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editCollection(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/collection_vouchers", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteCollection(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/collection_vouchers", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
   
  }
};
